import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { InboxStoreProvider } from '../../../stores/inbox/useInboxStore'
import { InboxModeProvider } from '../../../stores/inbox/InboxModeContext'
import { useAuthStore } from '../../../stores/auth/useAuthStore'
import InboxPage from '../components/inbox/InboxPage'
import { ApplyDefaultInboxView } from './InboxSection'

/**
 * The workspace's shared inbox: the same inbox UI over every proxy LinkedIn account the
 * user may see.
 *
 * It gets its own inbox store — nested inside the app-wide one the personal inbox uses — so
 * the two never mix lists, selection or filters, and switching between them starts clean.
 * Keyed by workspace for the same reason: another workspace has other accounts.
 */
const SharedInboxSection: FunctionComponent = () => {
    const { store: { workspace } } = useAuthStore()

    return (
        <InboxModeProvider mode="shared">
            <InboxStoreProvider key={workspace?._id ?? 'none'}>
                <ApplyDefaultInboxView />
                <Container>
                    <InboxPage />
                </Container>
            </InboxStoreProvider>
        </InboxModeProvider>
    )
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

export default SharedInboxSection
